export default "__VITE_ASSET__g5sdQYN$__"